module.exports = __webpack_public_path__ + "static/scale-model-of-simcenter-tampa-bay-in-clearwater-florida-48cb0272a12aefa54f270ed7a3162a23.png";